import React from 'react';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';
import FullScreenVerticalCenterContent from '../../styledhtml/FullScreenVerticalCenterContent';

export default class NotFoundPage extends LogictryComponent {
  render() {
    return (
      <FullScreenVerticalCenterContent fullscreenHeight>
        <h1 style={{ textAlign: 'center' }}>Page Not Found</h1>
      </FullScreenVerticalCenterContent>
    );
  }
}
